<template>
  <div class="justify-center">
    <!-- @submit.prevent evita il refresh di default -->
    <q-form class="q-gutter-md"
            @submit.prevent="handleLogin"
            @reset="onReset"
            style="min-width: 25vw">

      <p>
        <q-input v-model="username"
                 :hint="$t('username')"
                 autocomplete="username"
                 maxlength="150"
                 id="id_username"
                 required
                 autofocus
                 />
      </p>

      <p>
        <q-input v-model="password"
                 :type="isPwd ? 'password' : 'text'"
                 :hint="$t('password')"
                 id="id_password"
                 autocomplete="current-password"
                 aria-describedby="password-help-block">
          <template #append>
            <q-icon :name="isPwd ? 'visibility_off' : 'visibility'"
                    class="cursor-pointer"
                    @click="isPwd = !isPwd" />
          </template>
        </q-input>
      </p>

      <p v-if="errorMessage">{{ errorMessage }}</p>

      <p class="row q-gutter-x-md q-pt-md">
        <q-btn unelevated rounded color="secondary"
               :label="$t('signin')" to="/signin" class="col" />
        <q-btn rounded color="primary"
               :label="$t('login')" type="submit" class="col" />
      </p>
    </q-form>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useMainStore } from '../stores/main'
import * as Sentry from '@sentry/vue'
import { isHandledAuthError } from '../services/error-handling'

/* ---------- stato locale ---------- */
const username      = ref('')
const password      = ref('')
const nextPath      = ref('/dashboard/')
const errorMessage  = ref(null)
const isPwd         = ref(true)

/* ---------- servizi ---------- */
const store  = useMainStore()
const router = useRouter()
const route  = useRoute()

/* ---------- funzioni ---------- */
function updateAfterLoginNextPath () {
  if ('next' in route.query) {
    nextPath.value = route.query.next
  }
}

async function handleLogin () {
  try {
    await store.login({ username: username.value, password: password.value })
    router.push(nextPath.value)
  } catch (err) {
    errorMessage.value = 'Impossibile accedere, verificare le credenziali inserite.'
    if (!isHandledAuthError(err)) {
      Sentry.captureException(err)
    }
  }
}

function onReset () {
  username.value     = ''
  password.value     = ''
  isPwd.value        = true
  errorMessage.value = null
}

/* ---------- lifecycle ---------- */
onMounted(updateAfterLoginNextPath)
</script>
